import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';

export const PLUGIN_NAME = 'sizeSelection';
const CONTAINER_NAME = '.product-sizes';

const mergeOptions = ($el, $containerEl, options = {}) => {
    const opts = Object.assign({}, $el.data(), $containerEl.data(), options);
    return opts;
};

const showFittingRoom = (selectedSize, ispreorder) => {
    const _fittingRoomErrorMsgNoPreorder = $('#fittingRoomErrorMsgNoPreorder');
    const _fittingRoomFieldSet = $('#fittingRoomFieldSet');
    if (_fittingRoomFieldSet.length === 0) {
        return;
    }

    $('#fittingRoomErrorMsgNoSizeSelected').hide();
    if (!$("#accordionTryOnItem").hasClass("accordion__item--active")) {
        $('.js-tryon-anchor').click();
    }

    if (ispreorder) {
        _fittingRoomErrorMsgNoPreorder.show();
        _fittingRoomFieldSet.hide();
        const fitItemSizes = getFitItemSizes();
        if (fitItemSizes !== undefined && $('#tryon-size-options-' + fitItemSizes).length > 0) {
            $('#tryon-size-options-' + fitItemSizes).prop("checked", false);
        }
        return;
    } else {
        _fittingRoomErrorMsgNoPreorder.hide();
        _fittingRoomFieldSet.show();
    }

    if ($('#previousSelectedSize').val().length > 0) {
        const _previousSelectedSize = $('#tryon-size-options-' + $('#previousSelectedSize').val());
        if (_previousSelectedSize.length > 0) {
            _previousSelectedSize.attr('disabled', false);
        }
    }

    const _currenctSelectedSize = $('#tryon-size-options-' + selectedSize);
    if (_currenctSelectedSize.length > 0) {
        _currenctSelectedSize.attr('disabled', true);
        _currenctSelectedSize.prop("checked", false);
        $('#previousSelectedSize').val(selectedSize);
    }
}

const toggleForFinalSale = (isFinalSale, finalSaleDefective) => {
    $(".js-free-shipping").toggle(!isFinalSale);
    if (isFinalSale || finalSaleDefective){
        $('#freeShippingReturns').hide();
        $('#freeShipping').show();
    } else {
        $('#freeShippingReturns').show();
        $('#freeShipping').hide();
    }
}

const getFitItemSizes = () => {
    return $('input[name=tryon-size-options]:checked').val();
}

const getHTMLJSSaveId = (value) => {
    return value.toString().replace(/[\W_]+/g,"");
}

const setEventListeners = ($el, opts) => {
    const pdpData = window.rcProps.pdp || {};
    const fitPredictor = window.rcProps.fitPredictor || {};

    $el.on('click', function() {
        const el = $(this);

        if (!pdpData.isFreeReturn) {
            $('#freeShippingReturns').hide();
        }

        if (opts.isAssignedSellableDefectItemPage) {
            $('#sellable-defect-item-disclaimer').show();
            $('#inventory-disclaimer').hide();
        } else {
            const defectItemPrice = opts.sellableDefectItemPrice;
            const defectItemLink = opts.sellableDefectItemLink;
            if (defectItemPrice.length > 0 && defectItemLink.length > 0) {
                $('#sellableDefectItemPrice').text(defectItemPrice);
                $('#sellableDefectItemLink').prop("href", defectItemLink);
                $('#sellableDefectItem').show();
            } else {
                $('#sellableDefectItem').hide();
            }
        }

        if (el.is(':disabled')){
            return;
        }

        const dataSize = opts.size;
        showFittingRoom(dataSize, opts.isPreorder);
        $('.product-sizes__size').removeClass('is-active');
        el.closest('.product-sizes__size').addClass('is-active');
        $('#code').val(opts.code);
        $('#sizeError').fadeOut();
        $('#sizeValue').val(dataSize);
        let showAfterPay = true;
        let showKlarna = true;

        const firstCtaContainer = $('.js-add-to-bag-btn-preorder').closest('.js-ctas__item');
        firstCtaContainer.removeClass('u-full-width');
        if (opts.isPreorder) {
            $("#sizeNotification").hide();
            $("#preorderinfo2").show();
            $("#preorderNotifyMe").show();
            if (opts.preorderDate) {
                $("#deliveryDate").html(opts.preorderDate);
                $("#delivery").show();
            } else {
                $("#delivery").hide();
            }
            $("#regularDelivery").hide();
            $('#DeliveryUrgencyMessaging').addClass("u-hide");
            $('.js-add-to-bag-btn').hide();
            $('.js-add-to-bag-btn-preorder').show();
            firstCtaContainer.addClass('u-full-width');
            $('.buy_now_element').hide();
            $('.liveChatEnabled').addClass("po_livechat");
            showAfterPay = false;
            showKlarna = false;
        } else if(opts.qty === 1) {
            $("#sizeNotification").show();
            $('.js-add-to-bag-btn').show();
            $('.js-add-to-bag-btn-preorder').hide();
            $("#delivery").hide();
            $("#preorderNotifyMe").hide();
            $("#regularDelivery").show();
            $('#DeliveryUrgencyMessaging').removeClass("u-hide");
            $("#preorderinfo2").hide();
            $('.buy_now_element').show();
        } else {
            $("#sizeNotification").hide();
            $('.js-add-to-bag-btn').show();
            $('.js-add-to-bag-btn-preorder').hide();
            $("#delivery").hide();
            $("#preorderNotifyMe").hide();
            $("#preorderinfo2").hide();
            if (pdpData.hasEstimatedDate) {
                $("#regularDelivery").show();
            }
            $('#DeliveryUrgencyMessaging').removeClass("u-hide");
            $('.buy_now_element').show();
        }

        if (window.rcProps.payment.afterPayEnabled) {
            if (showAfterPay) {
                $("#afterPayBox").show();
                $(".afterPayBoxMsg").hide();
                $(`#afterPayBox${getHTMLJSSaveId(dataSize)}`).show();
            } else {
                $("#afterPayBox").hide();
            }
        } else if (window.rcProps.payment.klarnaEnabled) {
            if (showKlarna) {
                $("#klarnaPayMsgOption").show();
                $(".installmentPlanBoxMsg").hide();
                $(`#installmentPlanMsg${getHTMLJSSaveId(dataSize)}`).show();
            } else {
                $("#klarnaPayMsgOption").hide();
            }
        }

        if ($('#size-ul li').length > 1 && !$('.size_fit_section.section_arrow').hasClass('active_arrowdown')) {
            $('#sizeFitLink').click();
        }

        if (opts.inventoryDisclaimer) {
            $('#inventory-disclaimer').html(opts.inventoryDisclaimer);
            $('#inventory-disclaimer').show();
        } else {
            $('#inventory-disclaimer').hide();
        }

        if (opts.onSale) {
            $('#retailPrice, .js-price-retail, #fullPriceContainer').addClass('u-hide');
            $('#fullPriceContainer').removeClass('u-flex');
            $('#markdownPrice, .js-price-sale').html(opts.priceFormatted);
            if($('#percentageOff').length) {
                $('#percentageOff').html(opts.discount)
            }
            $('#retailPriceStrikethrough').html(opts.regularPriceFormatted);
            $('#salePriceContainer, .js-price-sale-container').removeClass('u-hide');
            $('#salePriceContainer').addClass('loyalty-wrap');
        } else {
            $('#salePriceContainer, .js-price-sale-container').addClass('u-hide');
            $('#retailPrice, .js-price-retail').html(opts.priceFormatted).removeClass('u-hide');
            $('#fullPriceContainer').removeClass('u-hide');
            $('#fullPriceContainer').addClass('u-flex');
        }

        if (opts.screenReader) {
            if (opts.isPreorder) {
                $('.js-add-to-bag-btn-preorder').attr("aria-label", opts.screenReader);
            } else {
                $('.js-add-to-bag-btn').attr("aria-label", opts.screenReader);
            }
        }

        const $fitPredictorRoot = $('.fp-root');
        if (fitPredictor.show && $fitPredictorRoot.length) {
            const productData = ssp('get', 'product', $fitPredictorRoot.data('productId')) || {};
            productData.size = dataSize;
            productData.price = opts.price;
            if (opts.regularPrice !== opts.price) {
                productData.salePrice = opts.price;
            }
            productData.variantId = opts.code + '_' + dataSize;
            ssp('set', 'product', productData);
        }

        toggleForFinalSale(opts.finalSale, opts.finalSaleDefective);

        // Mark other colorways if this size is oos for that colorway
        $('.js-product-swatch').removeClass('product-swatches__swatch--oos');
        const colorsOos = opts.colorsOos;
        if (colorsOos) {
            for (let i = 0; i < colorsOos.length; i++) {
                const oosColorCode = colorsOos[i];
                $(`.js-product-swatch[data-swatch-code="${oosColorCode}"]`).addClass('product-swatches__swatch--oos');
            }
        }
    });

    if ($el.hasClass('size-clickable')) {
        $el.on('click', function(){
            const input = $(this);
            if(input.is(':checked') && typeof window.logEngagement === 'function'){
                let url = window.location.href;

                if (!opts.isBeauty) {
                    let r = new URL(url);
                    r.searchParams.set("size", opts.size);
                    r.searchParams.set("code", opts.code);
                    url =  r.href;

                    window.history.replaceState(null, document.title, url);
                }

                logEngagementWithDetails(url, 'PDP Size Click', 'Click', opts.size);
            }
        });
    }
};

export default function sizeSelection(el, options) {
    const $el = $(el);
    const opts = mergeOptions($el, $(CONTAINER_NAME), options);
    setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sizeSelection);


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/size-selection.js